import React, { useState } from "react";
import "./HomeComp1.css";

const HomeComp3 = () => {
    const [activeTab, setActiveTab] = useState("Coffee");
   
      const menuData = [
        {
          category: "Coffee",
          items: [
            { name: "Coffee Cappuccino", image: "/images/menu-1.jpg", price: "$5.90" },
            { name: "Coffee Cappuccino", image: "/images/menu-2.jpg", price: "$5.90" },
            { name: "Coffee Cappuccino", image: "/images/menu-3.jpg", price: "$5.90" },
            { name: "Coffee Cappuccino", image: "/images/menu-4.jpg", price: "$5.90" },
            { name: "Coffee Cappuccino", image: "/images/menu-1.jpg", price: "$5.90" },
            { name: "Coffee Cappuccino", image: "/images/menu-2.jpg", price: "$5.90" },
            { name: "Coffee Cappuccino", image: "/images/menu-3.jpg", price: "$5.90" },
            { name: "Coffee Cappuccino", image: "/images/menu-4.jpg", price: "$5.90" },
          ],
          
        },
        {
          category: "Main Dish",
          items: [
              { name: "Coffee Cappuccino", image: "/images/menu-1.jpg", price: "$5.90" },
              { name: "Coffee Cappuccino", image: "/images/menu-2.jpg", price: "$5.90" },
              { name: "Coffee Cappuccino", image: "/images/menu-3.jpg", price: "$5.90" },
              { name: "Coffee Cappuccino", image: "/images/menu-4.jpg", price: "$5.90" },
              { name: "Coffee Cappuccino", image: "/images/menu-1.jpg", price: "$5.90" },
              { name: "Coffee Cappuccino", image: "/images/menu-2.jpg", price: "$5.90" },
              { name: "Coffee Cappuccino", image: "/images/menu-3.jpg", price: "$5.90" },
              { name: "Coffee Cappuccino", image: "/images/menu-4.jpg", price: "$5.90" },
          ],
        },
        {
          category: "Drinks",
          items: [
              { name: "Coffee Cappuccino", image: "/images/menu-1.jpg", price: "$5.90" },
              { name: "Coffee Cappuccino", image: "/images/menu-2.jpg", price: "$5.90" },
              { name: "Coffee Cappuccino", image: "/images/menu-3.jpg", price: "$5.90" },
              { name: "Coffee Cappuccino", image: "/images/menu-4.jpg", price: "$5.90" },
              { name: "Coffee Cappuccino", image: "/images/menu-1.jpg", price: "$5.90" },
              { name: "Coffee Cappuccino", image: "/images/menu-2.jpg", price: "$5.90" },
              { name: "Coffee Cappuccino", image: "/images/menu-3.jpg", price: "$5.90" },
              { name: "Coffee Cappuccino", image: "/images/menu-4.jpg", price: "$5.90" },
          ],
        },
        {
          category: "Desserts",
          items: [
              { name: "Coffee Cappuccino", image: "/images/menu-1.jpg", price: "$5.90" },
              { name: "Coffee Cappuccino", image: "/images/menu-2.jpg", price: "$5.90" },
              { name: "Coffee Cappuccino", image: "/images/menu-3.jpg", price: "$5.90" },
              { name: "Coffee Cappuccino", image: "/images/menu-4.jpg", price: "$5.90" },
              { name: "Coffee Cappuccino", image: "/images/menu-1.jpg", price: "$5.90" },
              { name: "Coffee Cappuccino", image: "/images/menu-2.jpg", price: "$5.90" },
              { name: "Coffee Cappuccino", image: "/images/menu-3.jpg", price: "$5.90" },
              { name: "Coffee Cappuccino", image: "/images/menu-4.jpg", price: "$5.90" },
          ],
        },
      ];
  return (
    <>
    {/* <section className="ftco-menu bg-imagea">
      <div className="container text-center text-white">
      <div class="row justify-content-center mb-5" data-aos="fade-up">
      <div class="col-md-7 heading-section text-center">
      <span class="subheading">Discover</span>
      <h2 className="mb-4">Our Products</h2>
      <p className="p-color">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>
          </div>
        </div>
       
  
        <div className="row d-md-flex" data-aos="fade-up">
          <div className="col-lg-12 p-md-5">
            <div className="nav nav-pills justify-content-center">
              {menuData.map((category, index) => (
                <button
                  key={index}
                  className={`nav-link ${activeTab === category.category ? "active" : ""}`}
                  onClick={() => setActiveTab(category.category)}
                >
                  {category.category}
                </button>
              ))}
            </div>
            <div className="tab-content mt-4">
              {menuData.map((category, index) => (
                <div
                  key={index}
                  className={`tab-pane fade ${activeTab === category.category ? "show active" : ""}`}
                >
                  <div className="row">
                    {category.items.map((item, idx) => (
                      <div key={idx} className="col-md-3">
                        <div className="menu-entry text-center">
                          <img src={item.image} alt={item.name} width={200} height={200} className="img-fluid" />
                          <div className="text text-white pt-4">
                            <h3>{item.name}</h3>
                            <p className="p-color">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>
                            <p className="price"><span>{item.price}</span></p>
                            <p><a href="/cart" className="btn btn-primary btn-outline-primary rounded-0">Add to Cart</a></p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
   

       
      </div>
    </section> */}

  <section className="ftco-sections container-fluid img pt-5" id="ftco-testimony" style={{backgroundImage: 'url(images/bg_1.jpg)'}} data-stellar-background-ratio="0.5">
  <div className="overlay" ></div>
  <div className="container">
    <div className="row justify-content-center mb-5" data-aos="fade-up">
      <div className="col-md-7 heading-section text-center pt-4">
        <span className="subheading">Testimony</span>
        <h2 className="mb-4 z-1 text-white">Customers Says</h2>
        <p className="p-color"> Customer testimonials highlight the rich aroma, bold flavor, and smooth texture of our coffee powder. They showcase real experiences, emphasizing freshness, perfect strength, and an energizing effect. Each review reflects the joy of a perfect brew, making it an essential choice for coffee lovers.</p>
      </div>
    </div>
  </div>
  <div className="container-wrap">
    <div className="row d-flex no-gutters" data-aos="fade-up">
      <div className="col-lg align-self-sm-end">
        <div className="testimony">
          <blockquote>
            <p>“I've tried many coffee powders, but this one stands out with its rich aroma and bold flavor. Every sip feels like a fresh café experience at home!”</p>
          </blockquote>
          <div className="author d-flex mt-4">
            <div className="image mr-3 align-self-center">
              <img src="images/person_1.jpg" alt />
            </div>
            <div className="name align-self-center">Louise Kelly <span className="position">Illustrator Designer</span></div>
          </div>
        </div>
      </div>
      <div className="col-lg align-self-sm-end">
        <div className="testimony overlay">
          <blockquote>
            <p className="text-white">“From the first sip, I knew this coffee was special—it’s fresh, rich, and incredibly satisfying. The aroma alone is enough to wake me up, and the taste keeps me coming back. A must-have for every coffee lover!”</p>
          </blockquote>
          <div className="author d-flex mt-4">
            <div className="image mr-3 align-self-center">
              <img src="images/person_2.jpg" alt />
            </div>
            <div className="name align-self-center">Rajesh K <span className="position">Illustrator Designer</span></div>
          </div>
        </div>
      </div>
      <div className="col-lg align-self-sm-end">
        <div className="testimony">
          <blockquote>
            <p>“This coffee powder delivers a strong and authentic taste in every cup. Whether black or with milk, it brews perfectly and keeps me energized. It’s my favorite part of the day!"”</p>
          </blockquote>
          <div className="author d-flex mt-4">
            <div className="image mr-3 align-self-center">
              <img src="images/person_3.jpg" alt />
            </div>
            <div className="name align-self-center">Sandeep V <span className="position">Illustrator Designer</span></div>
          </div>
        </div>
      </div>
      <div className="col-lg align-self-sm-end">
        <div className="testimony overlay">
          <blockquote>
            <p>“If you love strong coffee with a smooth finish, this is the one for you. It has become my everyday essential!”</p>
          </blockquote>
          <div className="author d-flex mt-4">
            <div className="image mr-3 align-self-center">
              <img src="images/person_2.jpg" alt />
            </div>
            <div className="name align-self-center">Arvind T <span className="position">Illustrator Designer</span></div>
          </div>
        </div>
      </div>
      <div className="col-lg align-self-sm-end">
        <div className="testimony">
          <blockquote>
            <p>“The coffee powder has such a deep, rich aroma that fills my kitchen every morning. The taste is just as amazing—smooth, strong, and absolutely refreshing! ”</p>
          </blockquote>
          <div className="author d-flex mt-4">
            <div className="image mr-3 align-self-center">
              <img src="images/person_3.jpg" alt />
            </div>
            <div className="name align-self-center"> Akash P <span className="position">Illustrator Designer</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

 {/* <section className="ftco-section bg-imagea" >
  <div className="container">
    <div className="row justify-content-center"data-aos="fade-up" >
      <div className="col-md-7 heading-section  text-center">
        <h2 className="mb-4 text-white">Recent from blog</h2>
        <p className="p-color">Discover the rich world of coffee powder—exploring its types, brewing tips, and how to choose the perfect grind for your morning brew. From robust espresso blends to smooth filter coffee, learn everything you need to elevate your coffee game.</p>
      </div>
    </div>
    <div className="row d-flex" data-aos="fade-up">
      <div className="col-md-4 d-flex ">
        <div className="blog-entry align-self-stretch">
          <a href="blog-single.html" className="block-20" style={{backgroundImage: 'url("images/coffeeBg8.jpg")'}}>
          </a>
          <div className="text py-4 d-block">
            <div className="meta">
              <div><a href="#"  className="text-decoration-none">Oct 10, 2024</a></div>
              <div><a href="#"  className="text-decoration-none">Admin</a></div>
              <div><a href="#" className="meta-chat text-decoration-none"><span className="icon-chat" /> 3</a></div>
            </div>
            <h3 className="heading mt-2"><a href="#"  className="text-decoration-none">Storing Coffee Powder: Tips to Keep Your Coffee Fresh for Longer</a></h3>
            <p className="p-color">Best practices for storing coffee powder to maintain its aroma, flavor, and freshness.</p>
          </div>
        </div>
      </div>
      <div className="col-md-4 d-flex ">
        <div className="blog-entry align-self-stretch">
          <a href="blog-single.html" className="block-20" style={{backgroundImage: 'url("images/coffeeBg6.jpg")'}}>
          </a>
          <div className="text py-4 d-block">
            <div className="meta">
              <div><a href="#"  className="text-decoration-none">Nov 1, 2024</a></div>
              <div><a href="#"  className="text-decoration-none">Admin</a></div>
              <div><a href="#" className="meta-chat text-decoration-none" ><span className="icon-chat" /> 3</a></div>
            </div>
            <h3 className="heading mt-2"><a href="#"  className="text-decoration-none">DIY Coffee Powder Blends: How to Create Your Signature Coffee Mix</a></h3>
            <p className="p-color">Learn how to mix different coffee beans and spices to create a unique coffee blend at home.</p>
          </div>
        </div>
      </div>
      <div className="col-md-4 d-flex ">
        <div className="blog-entry align-self-stretch">
          <a href="blog-single.html" className="block-20" style={{backgroundImage: 'url("images/coffeeBg5.jpg")'}}>
          </a>
          <div className="text py-4 d-block">
            <div className="meta">
              <div><a href="#" className="text-decoration-none">Sept 20, 2024</a></div>
              <div><a href="#"  className="text-decoration-none">Admin</a></div>
              <div><a href="#" className="meta-chat text-decoration-none"><span className="icon-chat " /> 3</a></div>
            </div>
            <h3 className="heading mt-2"><a href="#"  className="text-decoration-none">The Art of Brewing: Choosing the Right Coffee Powder for Your Taste</a></h3>
            <p className="p-color">A guide to selecting the best coffee powder based on roast levels, grind size, and brewing methods.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> */}
    </>
  );
};

export default HomeComp3;
